export const proceedToNextBiteDataSet = { cy: 'proceed-to-next-bite' };
